import '../style.scss';
import { Caption } from 'views/mutual/caption';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { CorporateAccountOpenProfileDetailsPages, useCorporateAccountOpenProfileDetailsPageTypeStore } from 'views/pages/accountOpenProfileDetails/corporateProfileDetails/hooks';
import { InputTemplate, MaskType } from 'views/templates/module/inputTemplate';
import { FormContentHeader, FormType } from 'views/templates/module/contentHeader';
import { useContactInfo } from './hooks';
import { TemplateProps } from '../common';
import { useCustomLocationName } from 'views/mutual/location/hooks';

export type ContactInfoProps = {
  formik: any;
  contactPhoneNumberProps: any;
  contactConfirmPhoneNumberProps: any;
  contactFaxNumberProps: any;
};

export const ContactInfoWrapper = () => {
  return <ContactInfo {...useContactInfo({ isUpdate: false })} />;
};

export const ContactInfo = ({
  formik,
  contactPhoneNumberProps,
  contactConfirmPhoneNumberProps,
  contactFaxNumberProps,
  isUpdate,
}: ContactInfoProps & TemplateProps) => {
  const { setAccountOpenProfileDetailsPageType } = useCorporateAccountOpenProfileDetailsPageTypeStore();

  useCustomLocationName('口座開設申込みフォーム');

  return (
    <form onSubmit={formik.handleSubmit} className="accountOpenTemplate">
      <div className="accountOpenTemplate">
        {!isUpdate && <Caption label="連絡先情報" />}
        <div className="accountOpenTemplate_input">
          <FormContentHeader label="電話番号" formType={FormType.Required} />
          <div className="accountOpenTemplate_input_wrapper">
            <InputTemplate
              type="tel"
              placeholder="例：0352885692（ハイフンは不要です）"
              maxLength={11}
              masked={isUpdate ? { type: MaskType.Start, displayedCount: 4 } : undefined}
              {...contactPhoneNumberProps}
            />
          </div>
          <FormContentHeader label="電話番号（確認用）" formType={FormType.Required} />
          <div className="accountOpenTemplate_input_wrapper">
            <InputTemplate
              type="tel"
              placeholder="例：0352885692（ハイフンは不要です）"
              maxLength={11}
              masked={isUpdate ? { type: MaskType.Start, displayedCount: 4 } : undefined}
              {...contactConfirmPhoneNumberProps}
            />
          </div>
          <FormContentHeader label="FAX番号" formType={FormType.Optional} />
          <div className="accountOpenTemplate_input_wrapper">
            <InputTemplate
              type="tel"
              placeholder="例：0352889300（ハイフンは不要です）"
              maxLength={10}
              masked={isUpdate ? { type: MaskType.Start, displayedCount: 4 } : undefined}
              {...contactFaxNumberProps}
            />
          </div>
        </div>
        {!isUpdate && (
          <div className="accountOpenTemplate_button">
            <Button
              type={ButtonType.Submit}
              label="次へ"
              buttonFill={ButtonFill.black}
              buttonSize={ButtonSize.medium}
            />
            <Button
              label="前の画面に戻る"
              buttonFill={ButtonFill.link}
              buttonSize={ButtonSize.small}
              onClick={() => setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.transactionPurpose)}
            />
          </div>
        )}
      </div>
    </form>
  );
};
